import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[vfs-qa-id]'
})
export class QaDirective implements OnInit {
  /* The name is received from each component */
  @Input('vfs-qa-id') id: string;

  constructor(public renderer: Renderer2, public hostElement: ElementRef) {}

  /**
   * OnInit
   * set data attribute with the assigned id.
   * necessary to identify the elements in the Qa tests.
   */
  ngOnInit() {
    this.renderer.setAttribute(this.hostElement.nativeElement, 'data-qa-id', this.id);
  }
}
